export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14586.30a4fa98.jpg";